import React from 'react';

export const Ai_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>AI ARTISTS</span>,
  },
];

export const DavidC_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>NEURAL VISUAL ARCHITECT</span>,
  },
];

export const DavidC_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Veteran editor with 20+ years in broadcast production. Today he
        integrates generative AI into real-world pipelines with visual
        consistency and a cinematic standard. No excuses. Just results.
      </span>
    ),
  },
];

export const DavidC_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>THE LAST CASE: An AI Noir Film.</span>,
  },
];

export const DavidC_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>Choose Your Role</span>,
  },
];

export const DavidC_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>BUNNYNJA</span>,
  },
];

export const AndresB_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>HYBRID NARRATIVE FILMMAKER</span>,
  },
];

export const AndresB_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Director and producer working across fiction, documentary, and AI-driven
        storytelling. Based in Barcelona, he combines classic on-set craft with
        advanced technical exploration—always in service of human stories.
        Versatile, authorial, and precise.
      </span>
    ),
  },
];

export const AndresB_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>ZOMBIE PATROL</span>,
  },
];

export const AndresB_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>TIMELINE. (A.I. Shortfilm)</span>,
  },
];

export const AndresB_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>MODE. (A.I. Shortfilm)</span>,
  },
];

export const AndresB_Video4 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>BetVIP</span>,
  },
];

export const AndresB_Video5 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>IMMMU</span>,
  },
];

export const AlvaroC_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>GENERATIVE WORKFLOW DESIGNER</span>,
  },
];

export const AlvaroC_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Editor with 10+ years of experience, focused on rhythm, emotion, and
        narrative. Today he integrates generative AI into hybrid workflows to
        expand what’s possible without losing editorial control. Precision,
        detail, and collaboration.
      </span>
    ),
  },
];

export const AlvaroC_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>ATHLA</span>,
  },
];

export const AlvaroC_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>FREE</span>,
  },
];

export const AlvaroC_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>GHOST MEMORY</span>,
  },
];

export const Robot_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>CRAFT & INDUSTRY ORCHESTRATORS</span>,
  },
];

export const Robot_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        A director duo shaped by the set and the advertising world. Craft,
        rhythm, and staging at the core, with AI integrated as a narrative tool.
        <br />
        <br />
        Hybrid productions with strong authorship and visual solidity.
      </span>
    ),
  },
];

export const Robot_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>La nombramos Perú - VEO 3</span>,
  },
];

export const Robot_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>Adidas</span>,
  },
];

export const Robot_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>Ad Monster</span>,
  },
];

export const DavidN_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>SYNTHETIC NARRATIVE ENGINEER</span>,
  },
];

export const DavidN_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Director and post-producer with 13 years in Buenos Aires and experience
        with Warner, Disney, and Viacom. Today he creates hybrid narratives
        through generative AI and interactive experiences, using technology as a
        creative engine without losing direction or storytelling.
      </span>
    ),
  },
];

export const DavidN_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>Chanel 11.12 - Concept</span>,
  },
];

export const DavidN_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>PLUTOCRACIA</span>,
  },
];

export const DavidN_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>DÍA DE MUERTOS</span>,
  },
];

export const MiguelTamara_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>ANIMATION DIRECTORS</span>,
  },
];

export const MiguelTamara_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Creative duo specialized in turning ideas into animated universes
        with an identity of their own. Tamara Llorens and Miguel Picazo
        combine art direction, character development, visual storytelling,
        and AI-assisted animation workflows. With award-winning projects
        selected at animation festivals and competitions, their work moves
        between entertainment, advertising, and new digital narratives.
      </span>
    ),
  },
];

export const MiguelTamara_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>PIZZA SLICE HEIST</span>,
  },
];

export const MiguelTamara_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>LANZAROTE</span>,
  },
];

export const MiguelTamara_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>EGGENTS - TEASER</span>,
  },
];

export const JJUnicorn_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>AUTHOR OF AUDIOVISUAL UNIVERSES</span>,
  },
];

export const JJUnicorn_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Director and audiovisual creator who turns ideas into expansive
        visual universes for younger audiences. His approach is
        comprehensive: he masters everything from script genesis and
        character design to animation architecture, music, and editing. He
        has built his digital footprint as director and producer of the
        animated series Las Perrerías de Mike, on Mikecrack's channel —
        Spain's most followed creator, with over 56 million subscribers.
      </span>
    ),
  },
];

export const JJUnicorn_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>JJUnicorn</span>,
  },
];
